import useViewport from '../functions/viewport'

import MobileComponent from './MobileComponent/MobileComponent'
import DesktopComponent from './DesktopComponent/DesktopComponent'

const HomePage = () => {
  const { width } = useViewport()

  return width < 550 ? <MobileComponent /> : <DesktopComponent />
}

export default HomePage
